import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: '新築マンションの引越業務効率化をシステム開発で実現',
  title1: '新築マンションの引越業務効率化をシステム開発で実現',
  introduction_text:
    '新築マンションの「一斉入居」の日程調整をデジタル化しました。通常の引越とは異なり、一斉入居では全ての入居者の引越日時を調整する必要があります。このプロジェクトは、入居者様へのサービス向上と関係会社の業務効率化を目的としています。弊社は、UX/UIデザインからシステム開発まで一貫して実施しました。',
  company: 'アート引越センター株式会社',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'クラウドネイティブ',
  tag2src: '/cases/cloudnative/',
  tag3text: 'UX/UI改善',
  tag3src: '/cases/uxui-improvement/',
  industryTagText: 'サービス',
  industryTagSrc: '/cases/service/',
  color: '#fff',
  background: '#0A71F0',
  staff1: 'アート引越センター株式会社 不動産法人営業部 法人営業1課 係長　歌津 一明さん',
  image: '/images/img/cases/mss/top.png',
  alt: '新築マンションの引越業務効率化をシステム開発で実現',
  imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = '業務に合わせたシステム開発で工数削減を実現'
export const overviewItem: OverviewItems[] = [
  {
    text: '「一斉入居」という言葉をご存じでしょうか？　新築マンションの引越は、通常の引越とは異なり、一度にすべての入居者がバラバラに引越を行なってしまうと大きな混乱が生じてしまいます。そのため幹事となる会社がそれぞれの入居者と引越日時の調整を行うのが「一斉入居」です。',
  },
  {
    text: '引越業界のリーディングカンパニーであるアート引越センターから、Aitriaにご依頼いただいたのは、そんな一斉入居の日程調整のデジタル化。同社の不動産法人営業部 法人営業1課 係長の歌津 一明さんに、ご依頼の経緯や、実際にプロジェクトを進めてどう感じられ、今回のDXがどのような成果を生んでいるのかを伺いました。',
    nonMargin: true,
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '大規模な一斉入居の効率化',
        text: '新築マンションの一斉入居において、入居者ごとの日程調整や書類の管理が膨大な労力を要していた。',
      },
      {
        title: '紙ベースのプロセスのデジタル化',
        text: '従来の紙と郵便に依存したプロセスをデジタル化し、手間や時間を削減する必要があった。',
      },
      {
        title: 'エコロジーと効率の向上',
        text: '紙の使用量を減らし、エコフレンドリーな業務運営を実現すると同時に、作業の効率化を図る。',
      },
    ],
    solutions: [
      {
        title: 'デジタル化プラットフォームの開発',
        text: '入居者がスマートフォンを使用して引越日程を簡単に設定できるシステムを開発し、全プロセスのデジタル化を推進。',
      },
      {
        title: 'リアルタイムデータの可視化',
        text: '引越し希望日や入居者の情報をリアルタイムで可視化し、管理と調整の効率化を図る。',
      },
      {
        title: 'ユーザーエクスペリエンスの向上',
        text: 'シンプルで直感的なインターフェースを持つウェブアプリケーションを提供し、利用者の便利さと満足度を向上させた。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: '「うちは特殊だから」を、変えない理由にしていませんか？',
  description:
    '業界特有の複雑な業務を深く理解した上で、AI駆動の開発とUX/UIデザインを一気通貫で担い、"本当に使われる"デジタル化を実現します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
